module.exports = __webpack_public_path__ + "static/media/dark-motion-deployment-scenario.add9f14.mp4";